import { MessageTemplateParser } from '$shared/helpers/MessageTemplateParser';
import type { IMessageTemplate } from '$shared/interfaces/api/IMessageTemplate';

export default class MessageTemplate {
  readonly messageTemplate: string;
  readonly messageParams: Record<string, string>;

  constructor(template: IMessageTemplate) {
    this.messageTemplate = template?.messageTemplate;
    this.messageParams = template?.messageParams;
  }

  get message(): string {
    return MessageTemplateParser.parseMessageTemplate(this.messageTemplate, this.messageParams);
  }
}
